var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrinite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 247,
    viewBox: "0 0 262 247",
    width: 262,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    fill: "#fff",
    fillRule: "nonzero",
    r: 75,
    stroke: "#fc0"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#444",
    fontFamily: "Lato",
    fontSize: 16,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46,
    y: 81
  }, "Vouloir"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 96)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    fill: "#fff",
    fillRule: "nonzero",
    r: 75,
    stroke: "#fc0"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#444",
    fontFamily: "Lato",
    fontSize: 16,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 81
  }, "Savoir"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111 96)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    fill: "#fff",
    fillRule: "nonzero",
    r: 75,
    stroke: "#fc0"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#444",
    fontFamily: "Lato",
    fontSize: 16,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 44,
    y: 81
  }, "Pouvoir"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrinite);
export default __webpack_public_path__ + "static/media/trinite.a2dd242c.svg";
export { ForwardRef as ReactComponent };